/**
 * PrivacyPolicyPage
 *
 * Public route: /privacy
 *
 * Required by Shopify for Public App Review.
 * URL to register in Partner Dashboard → App setup → Privacy policy URL:
 *   https://app.axelio.biz/privacy
 */

import { Link } from 'react-router-dom';

export function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 p-8 sm:p-12">

        {/* Header */}
        <div className="mb-10">
          <Link to="/" className="text-sm text-blue-600 hover:underline">
            ← Back to Axelio
          </Link>
          <h1 className="mt-6 text-3xl font-bold text-gray-900">
            Privacy Policy for Axelio Integration
          </h1>
          <p className="mt-2 text-sm text-gray-500">Last updated: April 2026</p>
        </div>

        {/* Body */}
        <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">

          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              1. Information We Collect
            </h2>
            <p>
              When you install the Axelio Integration app, we are automatically able to access
              certain types of information from your Shopify account, including read/write access
              to inventory and products, and read access to orders and customer details.
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              2. How We Use Your Information
            </h2>
            <p>
              We use the collected data strictly to provide the Axelio service—specifically, to
              sync your store's inventory, products, and orders into your Axelio dashboard for
              advanced management.
            </p>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              3. Data Retention and User Rights (GDPR)
            </h2>
            <p>
              We comply with Shopify's data privacy requirements. If a customer requests access
              to their data or asks to be deleted, or if you uninstall our app and request store
              data deletion, we process these requests automatically via Shopify's mandatory
              privacy webhooks (
              <code className="text-sm bg-gray-100 px-1 py-0.5 rounded">customers/data_request</code>,{' '}
              <code className="text-sm bg-gray-100 px-1 py-0.5 rounded">customers/redact</code>,{' '}
              <code className="text-sm bg-gray-100 px-1 py-0.5 rounded">shop/redact</code>
              ).
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              4. Contact Us
            </h2>
            <p>
              For any questions regarding your privacy, please contact us at:{' '}
              <a
                href="mailto:972cfe@gmail.com"
                className="text-blue-600 hover:underline"
              >
                972cfe@gmail.com
              </a>
            </p>
          </section>

        </div>

        {/* Footer */}
        <div className="mt-12 pt-6 border-t border-gray-100 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} Axelio. All rights reserved.
        </div>
      </div>
    </div>
  );
}
